export const mqSizes = {
    wide: 1200,
    tablet: 1024,
    mobile: 768,
    small: 480,
}

export const mq = {
    tablet: `screen and (max-width: ${mqSizes.tablet}px)`,
    mobile: `screen and (max-width: ${mqSizes.mobile}px)`,
    small: `screen and (max-width: ${mqSizes.small}px)`,
    desktop: `screen and (min-width: ${mqSizes.mobile}px)`,
    desktopMin: `screen and (min-width: ${mqSizes.mobile + 1}px)`,
    wide: `screen and (min-width: ${mqSizes.wide}px)`,
}

export const storagePath = '/storage'
export const uploadPath = '/api/upload-image'
export const uploadFilePath = '/api/upload-file'
export const customerActionPath = '/customer-action'

/**
 * Env variables
 */
// Old
// export const APP_URL = process.env.MIX_APP_URL
//     ? process.env.MIX_APP_URL
//     : 'http://notset.localhost'
export const APP_URL = window.location.origin
